<template>
	<div class="modal is-active">
		<div class="modal-background" @click="$emit('close')"></div>
		<div class="modal-card">
			<form @submit.prevent="$emit('confirm', {phone: phone, email: email})">
			<header class="modal-card-head">
				<h5 class="modal-card-title title is-5">
					{{ translations.title }}
				</h5>
				<button type="button" class="delete" aria-label="close" @click="$emit('close')"></button>
			</header>
			<section class="modal-card-body">
				<flashes :alerts="alerts.data" v-if="alerts.action === 'modal'"></flashes>
				<div class="field">
					<div class="control label-around-input">
						<label class="label" for="email">{{ translations.email }}</label>
						<input class="input" type="email" id="email" v-model="email">
					</div>
				</div>
				<p class="is-uppercase is-centered">{{ translations.or }}</p>
				<div class="field">
					<div class="control label-around-input">
						<label class="label" for="phone">{{ translations.phone }}</label>
						<input class="input" type="tel" id="phone" v-model="phone">
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<div class="container">
					<div class="columns is-multiline">
						<div class="column is-half">
							<button class="button is-fullwidth" @click.prevent="$emit('close')">{{ translations.cancel }}</button>
						</div>
						<div class="column is-half">
							<input type="submit" class="button is-success is-fullwidth" :value="translations.confirm">
						</div>
					</div>
				</div>
			</footer>
			</form>
		</div>
	</div>
</template>

<script>
	export default {
		name: "card-activation",
		props:
		[
			'translations',
			'alerts'
		],
		data ()
		{
			return {
				email: '',
				phone: ''
			}
		}
	}
</script>
